import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const managerialDocumentsService = {
  getAll,
  createOrUpdate,
  deleteDocument
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/managerial_documents/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newManagerialDocument) {
  const requestOptions = {
    method: newManagerialDocument.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newManagerialDocument)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/managerial_documents${
    newManagerialDocument.id ? `/${newManagerialDocument.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(managerialDocument) {
  let formData = new FormData();

  formData.append('managerial_document[title]', managerialDocument.title);
  formData.append('managerial_document[date]', managerialDocument.date);
  const document = managerialDocument.document;

  if (document) {
    if (document.url) {
      formData.append(`managerial_document[document]`, document.url);
    } else {
      formData.append(`managerial_document[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteDocument(managerialDocumentId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/managerial_documents/${managerialDocumentId}`;

  return axios.delete(url, requestOptionsDelete);
}
